/**
 * Persists the intended /admin/* URL across the client-portal login shell so
 * deep links resolve after explicit admin sign-in (CL-309.1).
 */

const STORAGE_KEY = "markbeattie_adminPostLoginReturn";

function safePath(p) {
  const s = (p || "").toString();
  if (!s.startsWith("/admin")) return "";
  return s;
}

export function storeAdminReturnPath(path) {
  const ok = safePath(path);
  if (!ok) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, ok);
  } catch {
    // ignore
  }
}

/** Read without removing (for redirect vs. gate ordering). */
export function peekAdminReturnPath() {
  try {
    return safePath(sessionStorage.getItem(STORAGE_KEY));
  } catch {
    return "";
  }
}

export function consumeAdminReturnPath() {
  const v = peekAdminReturnPath();
  if (!v) return null;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  return v;
}

export function clearAdminReturnPath() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

/** Set after successful email/password sign-in on the client-portal login form (CL-309.2). */
const PORTAL_EMAIL_LOGIN_KEY = "markbeattie_portalEmailLoginPending";

export function markPortalEmailLoginPending() {
  try {
    sessionStorage.setItem(PORTAL_EMAIL_LOGIN_KEY, "1");
  } catch {
    // ignore
  }
}

export function peekPortalEmailLoginPending() {
  try {
    return sessionStorage.getItem(PORTAL_EMAIL_LOGIN_KEY) === "1";
  } catch {
    return false;
  }
}

export function consumePortalEmailLoginPending() {
  try {
    sessionStorage.removeItem(PORTAL_EMAIL_LOGIN_KEY);
  } catch {
    // ignore
  }
}
